module.exports = __webpack_public_path__ + "img/service_6.svg";